import React from "react";

import { Field } from "react-final-form";
import { FormattedMessage, injectIntl } from "react-intl";

import { Button,FormSwitch } from "components";

// Import your local image
import loyaltyPointsIllustration from "../../assets/images/loyalty-points.jpeg"; // Update the path as per your project
import spendMoreIllustration from "../../assets/images/spend-more-illustration.webp"; // Update the path as per your project
import styles from "./JoinLoyaltyPointsField.module.scss";
import messages from "./messages";

const JoinLoyaltyPointsField = ({
  intl,
  readOnly,
  onBack,
  onSkip,
  onJoin,
}) => {
  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.headerBox}>
        <h2>Join The Loyalty Rewards Program!</h2>
      </div>

      {/* Description */}
      <div className={styles.descriptionBox}>
        <p>
          Boost customer loyalty and encourage repeat business by offering
          loyalty points. <strong>It’s free to join and easy to manage!</strong>
        </p>
      </div>

      {/* How It Works Section */}
      <div className={styles.howItWorksContainer}>
        <div className={styles.howItWorksBox}>
          <h5>How it works</h5>
          <ul>
            <li>
              <strong>Customer Pays:</strong> After a customer pays their bill,
              they can request loyalty points from your page in the app.
            </li>
            <li>
              <strong>Instant Notification:</strong> You’ll instantly receive a
              pop-up in your account with the request.
            </li>
            <li>
              <strong>Review & Accept:</strong> You have up to 48 hours to
              review and accept the request.
            </li>
          </ul>
        </div>

        {/* Image */}
        {/* <div className={styles.placeholderBox}> */}
        <img
          src={loyaltyPointsIllustration}
          alt="Saleswoman taking payment from a customer"
          className={styles.illustration}
        />
      </div>

      {/* Bottom Text */}
      <div className={styles.bottomTextBox}>
        <p>Increase sales by motivating customers to spend more</p>
        <img
          src={spendMoreIllustration}
          alt="Spend more earn more illustration"
          className={styles.spendMoreGraphic}
        />
      </div>
    </div>
  );
};

export default injectIntl(JoinLoyaltyPointsField);
